export const mockData = {
  event: {
    name: "KNOWN CON 2025",
    date: "August 15-17, 2025",
    location: "Los Angeles Convention Center",
    countdown: new Date("2025-08-15T09:00:00").getTime()
  },
  
  speakers: [
    {
      id: 1,
      name: "Pastor Michael Chen",
      title: "Lead Pastor & Visionary",
      bio: "20+ years transforming lives through faith-based leadership",
      image: "https://images.unsplash.com/photo-1660794486110-7fca371c86b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBzcGVha2VyfGVufDB8fHx8MTc2MTMxNjcxN3ww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 2,
      name: "Dr. Sarah Williams",
      title: "Leadership Coach & Author",
      bio: "Bestselling author inspiring change-makers worldwide",
      image: "https://images.pexels.com/photos/8761549/pexels-photo-8761549.jpeg"
    },
    {
      id: 3,
      name: "Bishop Marcus Johnson",
      title: "Global Impact Leader",
      bio: "Building communities of faith across 30 nations",
      image: "https://images.unsplash.com/photo-1560439514-e960a3ef5019?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxwcmVzZW50ZXJ8ZW58MHx8fHwxNzYxMzE2NzI3fDA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 4,
      name: "Pastor David Martinez",
      title: "Youth & Culture Influencer",
      bio: "Bridging faith and culture for the next generation",
      image: "https://images.unsplash.com/photo-1709377303352-7c845ac999ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBzcGVha2VyfGVufDB8fHx8MTc2MTMxNjcxN3ww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 5,
      name: "Rev. Grace Thompson",
      title: "Worship Leader & Songwriter",
      bio: "Leading worship experiences that transform hearts",
      image: "https://images.pexels.com/photos/3184328/pexels-photo-3184328.jpeg"
    },
    {
      id: 6,
      name: "Prophet James Anderson",
      title: "Prophetic Voice & Teacher",
      bio: "Activating believers in their God-given purpose",
      image: "https://images.unsplash.com/photo-1560439513-74b037a25d84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxwcmVzZW50ZXJ8ZW58MHx8fHwxNzYxMzE2NzI3fDA&ixlib=rb-4.1.0&q=85"
    }
  ],
  
  experiences: [
    {
      id: 1,
      title: "Immersive Worship",
      description: "Experience powerful worship sessions with world-class musicians and worship leaders",
      image: "https://images.unsplash.com/photo-1507692049790-de58290a4334?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHx3b3JzaGlwfGVufDB8fHx8MTc2MTMxNjc3MXww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 2,
      title: "Group Connections",
      description: "Connect with like-minded believers in intimate small group sessions",
      image: "https://images.unsplash.com/photo-1760454477189-9af9947786ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxjb21tdW5pdHklMjBnYXRoZXJpbmd8ZW58MHx8fHwxNzYxMzE2NzY0fDA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 3,
      title: "Leadership Sessions",
      description: "Learn from industry leaders and faith pioneers in interactive workshops",
      image: "https://images.unsplash.com/photo-1438232992991-995b7058bbb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHx3b3JzaGlwfGVufDB8fHx8MTc2MTMxNjc3MXww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 4,
      title: "Marketplace & Vendors",
      description: "Explore faith-based products, resources, and ministry opportunities",
      image: "https://images.unsplash.com/photo-1522158637959-30385a09e0da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHx3b3JzaGlwfGVufDB8fHx8MTc2MTMxNjc3MXww&ixlib=rb-4.1.0&q=85"
    }
  ],
  
  whoItsFor: [
    {
      id: 1,
      title: "Leaders",
      description: "Equip yourself with tools and insights to lead with purpose and impact in your community"
    },
    {
      id: 2,
      title: "Believers",
      description: "Deepen your faith journey through powerful teachings and authentic worship experiences"
    },
    {
      id: 3,
      title: "Change-Makers",
      description: "Connect with a movement of believers committed to transforming culture through faith"
    }
  ],
  
  involvement: [
    {
      id: 1,
      title: "Become a Sponsor",
      description: "Partner with us to make KNOWN CON accessible to thousands"
    },
    {
      id: 2,
      title: "Be a Volunteer",
      description: "Serve alongside us and be part of something greater"
    },
    {
      id: 3,
      title: "Become a Vendor",
      description: "Showcase your products and services to our community"
    }
  ],
  
  movement: [
    {
      id: 1,
      title: "Join a Group",
      description: "Connect with a local group and build lasting relationships"
    },
    {
      id: 2,
      title: "Get Baptized",
      description: "Take your next step in faith and declare your commitment"
    },
    {
      id: 3,
      title: "Sign Up for Discipleship",
      description: "Grow in your faith through structured mentorship programs"
    },
    {
      id: 4,
      title: "Newsletter Signup",
      description: "Stay updated with the latest news and exclusive content"
    }
  ],
  
  conferenceInfo: [
    {
      id: 1,
      title: "Attendee Guide",
      link: "/guide"
    },
    {
      id: 2,
      title: "Hotel & Travel",
      link: "/travel"
    },
    {
      id: 3,
      title: "ADA Assistance",
      link: "/ada"
    },
    {
      id: 4,
      title: "FAQs",
      link: "/faq"
    }
  ],
  
  partners: [
    { id: 1, name: 'Faith United', logo: 'https://via.placeholder.com/150x60/1e3a8a/ffffff?text=Faith+United' },
    { id: 2, name: 'Community Church', logo: 'https://via.placeholder.com/150x60/d97706/ffffff?text=Community+Church' },
    { id: 3, name: 'Kingdom Networks', logo: 'https://via.placeholder.com/150x60/1e3a8a/ffffff?text=Kingdom+Networks' },
    { id: 4, name: 'Grace Foundation', logo: 'https://via.placeholder.com/150x60/d97706/ffffff?text=Grace+Foundation' },
    { id: 5, name: 'Faith Leaders', logo: 'https://via.placeholder.com/150x60/1e3a8a/ffffff?text=Faith+Leaders' },
    { id: 6, name: 'Unity Alliance', logo: 'https://via.placeholder.com/150x60/d97706/ffffff?text=Unity+Alliance' }
  ],

  // Speakers and Guests Data
  allSpeakers: [
    {
      id: 1,
      name: 'Dr. Sarah Mitchell',
      role: 'Lead Pastor & Author',
      organization: 'Grace Community Church',
      category: 'speaker',
      tags: ['Day 1', 'Leadership', 'Keynote'],
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=500&fit=crop',
      bio: 'Dr. Sarah Mitchell is a bestselling author and lead pastor with over 20 years of experience in transformational leadership. She has planted 15 churches and mentored thousands of emerging leaders worldwide.',
      sessions: [
        { title: 'Leading with Courage', day: 'Day 1', time: '9:00 AM', stage: 'Main Stage' },
        { title: 'Building Legacy', day: 'Day 1', time: '2:00 PM', stage: 'Leadership Hall' }
      ]
    },
    {
      id: 2,
      name: 'Marcus Johnson',
      role: 'Worship Leader',
      organization: 'Elevation Music',
      category: 'performer',
      tags: ['Day 1', 'Day 2', 'Worship'],
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=500&fit=crop',
      bio: 'Marcus Johnson is a renowned worship leader whose music has touched millions. With multiple Grammy nominations, he brings a powerful blend of contemporary worship and authentic faith expression.',
      sessions: [
        { title: 'Opening Night Worship', day: 'Day 1', time: '7:00 PM', stage: 'Main Stage' }
      ]
    },
    {
      id: 3,
      name: 'Bishop David Chen',
      role: 'Global Impact Leader',
      organization: 'Kingdom Network International',
      category: 'speaker',
      tags: ['Day 2', 'Leadership', 'Business', 'Keynote'],
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=500&fit=crop',
      bio: 'Bishop David Chen leads one of the fastest-growing faith networks globally, impacting 50+ nations. He brings expertise in marketplace ministry and kingdom business principles.',
      sessions: [
        { title: 'Faith in the Marketplace', day: 'Day 2', time: '10:00 AM', stage: 'Business Forum' },
        { title: 'Kingdom Economics', day: 'Day 2', time: '3:00 PM', stage: 'Main Stage' }
      ]
    },
    {
      id: 4,
      name: 'Pastor Joy Williams',
      role: 'Youth Ministry Pioneer',
      organization: 'NextGen Movement',
      category: 'speaker',
      tags: ['Day 3', 'Youth', 'Leadership'],
      image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=500&fit=crop',
      bio: 'Pastor Joy Williams has revolutionized youth ministry with innovative approaches that engage the next generation. Her ministry reaches over 100,000 young people annually.',
      sessions: [
        { title: 'Awakening the Next Generation', day: 'Day 3', time: '11:00 AM', stage: 'Youth Arena' }
      ]
    },
    {
      id: 5,
      name: 'Rev. Michael Anderson',
      role: 'Conference Host',
      organization: 'Known Conference',
      category: 'host',
      tags: ['Day 1', 'Day 2', 'Day 3'],
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=500&fit=crop',
      bio: 'Rev. Michael Anderson is the visionary founder of KNOWN Conference. His passion for bringing together leaders, believers, and change-makers has created one of the most impactful faith gatherings.',
      sessions: []
    },
    {
      id: 6,
      name: 'Dr. Grace Thompson',
      role: 'Prophetic Voice & Teacher',
      organization: 'Breakthrough Ministry',
      category: 'speaker',
      tags: ['Day 2', 'Day 3', 'Leadership'],
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=500&fit=crop',
      bio: 'Dr. Grace Thompson is recognized globally as a prophetic voice for this generation. Her teaching ministry has equipped thousands to walk in their divine calling.',
      sessions: [
        { title: 'Prophetic Activation', day: 'Day 2', time: '4:00 PM', stage: 'Prayer Hall' }
      ]
    },
    {
      id: 7,
      name: 'James Martinez',
      role: 'Gospel Artist',
      organization: 'Independent',
      category: 'performer',
      tags: ['Day 2', 'Worship'],
      image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=500&fit=crop',
      bio: 'James Martinez is a chart-topping gospel artist whose powerful voice and authentic worship style have made him a favorite at conferences worldwide.',
      sessions: [
        { title: 'Saturday Night Concert', day: 'Day 2', time: '8:00 PM', stage: 'Main Stage' }
      ]
    },
    {
      id: 8,
      name: 'Pastor Lisa Park',
      role: 'Marriage & Family Expert',
      organization: 'Strong Families Ministry',
      category: 'speaker',
      tags: ['Day 1', 'Leadership'],
      image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=500&fit=crop',
      bio: 'Pastor Lisa Park specializes in strengthening marriages and families. Her practical wisdom and compassionate approach have restored thousands of relationships.',
      sessions: [
        { title: 'Building Strong Families', day: 'Day 1', time: '1:00 PM', stage: 'Family Center' }
      ]
    },
    {
      id: 9,
      name: 'Apostle John Roberts',
      role: 'Apostolic Leader',
      organization: 'Global Apostolic Network',
      category: 'special',
      tags: ['Day 3', 'Leadership', 'Keynote'],
      image: 'https://images.unsplash.com/photo-1556157382-97eda2d62296?w=400&h=500&fit=crop',
      bio: 'Apostle John Roberts is a respected apostolic leader who has pioneered church planting movements across continents. His wisdom and experience guide leaders worldwide.',
      sessions: [
        { title: 'The Apostolic Call', day: 'Day 3', time: '9:00 AM', stage: 'Main Stage' }
      ]
    },
    {
      id: 10,
      name: 'Hannah Rodriguez',
      role: 'Worship Artist',
      organization: 'Bethel Music',
      category: 'performer',
      tags: ['Day 3', 'Worship'],
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=500&fit=crop',
      bio: 'Hannah Rodriguez brings a fresh sound to worship music. Her heartfelt songs and anointed ministry create powerful moments of encounter with God.',
      sessions: [
        { title: 'Sunday Morning Worship', day: 'Day 3', time: '10:00 AM', stage: 'Main Stage' }
      ]
    },
    {
      id: 11,
      name: 'Dr. Samuel Lee',
      role: 'Business Leader & Author',
      organization: 'Kingdom Business Institute',
      category: 'speaker',
      tags: ['Day 2', 'Business', 'Leadership'],
      image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=500&fit=crop',
      bio: 'Dr. Samuel Lee bridges faith and business, teaching entrepreneurs how to build kingdom-minded companies. His bestselling books have transformed business culture.',
      sessions: [
        { title: 'Kingdom Entrepreneurship', day: 'Day 2', time: '1:00 PM', stage: 'Business Forum' }
      ]
    },
    {
      id: 12,
      name: 'Pastor Rachel Green',
      role: 'Social Justice Advocate',
      organization: 'Justice & Mercy Collective',
      category: 'speaker',
      tags: ['Day 1', 'Day 3', 'Leadership'],
      image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=400&h=500&fit=crop',
      bio: 'Pastor Rachel Green is a passionate advocate for social justice and community transformation. Her ministry has established programs serving thousands in underserved communities.',
      sessions: [
        { title: 'Faith in Action', day: 'Day 3', time: '2:00 PM', stage: 'Community Center' }
      ]
    }
  ],

  // Schedule Data
  scheduleData: {
    day1: {
      name: 'Friday',
      date: 'August 15, 2025',
      sessions: [
        {
          id: 1,
          time: '9:00 AM - 10:00 AM',
          title: 'Opening Keynote: Leading with Courage',
          speaker: 'Dr. Sarah Mitchell',
          venue: 'Main Stage',
          category: 'Keynote',
          description: 'Discover the courage needed to lead in uncertain times and make bold faith-driven decisions.',
          image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=300&fit=crop',
          featured: true
        },
        {
          id: 2,
          time: '10:30 AM - 11:30 AM',
          title: 'Building Strong Families',
          speaker: 'Pastor Lisa Park',
          venue: 'Family Center',
          category: 'Workshop',
          description: 'Practical wisdom for strengthening marriages and raising children with purpose.',
          image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=300&fit=crop'
        },
        {
          id: 3,
          time: '10:30 AM - 11:30 AM',
          title: 'Faith in Action',
          speaker: 'Pastor Rachel Green',
          venue: 'Community Center',
          category: 'Panel',
          description: 'Social justice and community transformation through faith-based initiatives.',
          image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=400&h=300&fit=crop'
        },
        {
          id: 4,
          time: '12:00 PM - 1:00 PM',
          title: 'Leadership Lunch & Network',
          speaker: 'Multiple Hosts',
          venue: 'Networking Hall',
          category: 'Networking',
          description: 'Connect with fellow leaders over lunch and build lasting relationships.'
        },
        {
          id: 5,
          time: '2:00 PM - 3:00 PM',
          title: 'Building Legacy',
          speaker: 'Dr. Sarah Mitchell',
          venue: 'Leadership Hall',
          category: 'Workshop',
          description: 'Create lasting impact through intentional leadership and legacy planning.'
        },
        {
          id: 6,
          time: '7:00 PM - 9:00 PM',
          title: 'Opening Night Worship Experience',
          speaker: 'Marcus Johnson',
          venue: 'Main Stage',
          category: 'Worship',
          description: 'Powerful worship night to launch the conference with praise and encounter.',
          image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop',
          featured: true
        }
      ]
    },
    day2: {
      name: 'Saturday',
      date: 'August 16, 2025',
      sessions: [
        {
          id: 7,
          time: '9:00 AM - 10:30 AM',
          title: 'Faith in the Marketplace',
          speaker: 'Bishop David Chen',
          venue: 'Business Forum',
          category: 'Keynote',
          description: 'Integrating faith and business principles for kingdom impact in the marketplace.',
          image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=300&fit=crop',
          featured: true
        },
        {
          id: 8,
          time: '11:00 AM - 12:00 PM',
          title: 'Kingdom Entrepreneurship',
          speaker: 'Dr. Samuel Lee',
          venue: 'Business Forum',
          category: 'Workshop',
          description: 'Building kingdom-minded businesses that generate wealth and impact.',
          image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=300&fit=crop'
        },
        {
          id: 9,
          time: '11:00 AM - 12:00 PM',
          title: 'Treasure Hunt Adventure',
          speaker: 'Conference Facilitators',
          venue: 'Throughout Venue',
          category: 'Interactive',
          description: 'Prophetic adventure connecting attendees through divine appointments.'
        },
        {
          id: 10,
          time: '1:00 PM - 2:00 PM',
          title: 'Marketplace Experience',
          speaker: 'Vendors & Exhibitors',
          venue: 'Marketplace Hall',
          category: 'Networking',
          description: 'Explore faith-based products, resources, and ministry opportunities.'
        },
        {
          id: 11,
          time: '3:00 PM - 4:30 PM',
          title: 'Kingdom Economics',
          speaker: 'Bishop David Chen',
          venue: 'Main Stage',
          category: 'Keynote',
          description: 'Understanding biblical economics and stewarding resources for impact.'
        },
        {
          id: 12,
          time: '4:00 PM - 5:00 PM',
          title: 'Prophetic Activation',
          speaker: 'Dr. Grace Thompson',
          venue: 'Prayer Hall',
          category: 'Workshop',
          description: 'Activating believers to walk in their prophetic calling and gifts.',
          image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=300&fit=crop'
        },
        {
          id: 13,
          time: '8:00 PM - 10:00 PM',
          title: 'Saturday Night Concert',
          speaker: 'James Martinez & Special Guests',
          venue: 'Main Stage',
          category: 'Worship',
          description: 'Chart-topping gospel concert with powerful worship and celebration.',
          image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=300&fit=crop',
          featured: true
        }
      ]
    },
    day3: {
      name: 'Sunday',
      date: 'August 17, 2025',
      sessions: [
        {
          id: 14,
          time: '9:00 AM - 10:30 AM',
          title: 'The Apostolic Call',
          speaker: 'Apostle John Roberts',
          venue: 'Main Stage',
          category: 'Keynote',
          description: 'Understanding apostolic leadership and pioneering movements.',
          image: 'https://images.unsplash.com/photo-1556157382-97eda2d62296?w=400&h=300&fit=crop'
        },
        {
          id: 15,
          time: '10:00 AM - 11:00 AM',
          title: 'Sunday Morning Worship',
          speaker: 'Hannah Rodriguez',
          venue: 'Main Stage',
          category: 'Worship',
          description: 'Heartfelt worship and powerful ministry time.',
          image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=300&fit=crop'
        },
        {
          id: 16,
          time: '11:00 AM - 12:00 PM',
          title: 'Awakening the Next Generation',
          speaker: 'Pastor Joy Williams',
          venue: 'Youth Arena',
          category: 'Workshop',
          description: 'Revolutionary approaches to engaging and equipping young people.',
          image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=300&fit=crop'
        },
        {
          id: 17,
          time: '12:00 PM - 1:00 PM',
          title: 'Baptism Service',
          speaker: 'Multiple Pastors',
          venue: 'Baptism Pool',
          category: 'Special',
          description: 'Public declaration of faith through water baptism.'
        },
        {
          id: 18,
          time: '2:00 PM - 3:00 PM',
          title: 'Faith in Action',
          speaker: 'Pastor Rachel Green',
          venue: 'Community Center',
          category: 'Panel',
          description: 'Practical ways to serve and transform your community.'
        },
        {
          id: 19,
          time: '3:00 PM - 4:30 PM',
          title: 'Closing Celebration & Commission',
          speaker: 'All Speakers',
          venue: 'Main Stage',
          category: 'Special',
          description: 'Final worship, prayer, and commissioning to go and make impact.',
          image: 'https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=400&h=300&fit=crop',
          featured: true
        }
      ]
    }
  }
};
